import axios from "axios";
import {
  registerRoute,
  loginRoute,
  forgotPasswordRoute,
  verifyOtpRoute,
  resetPasswordRoute,
  verifySessionRoute,
} from "../common/endpoints";

export const registerUser = async (userData) => {
  const config = {
    method: "post",
    url: registerRoute,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(userData),
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const loginUser = async (userData) => {
  const config = {
    method: "post",
    url: loginRoute,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(userData),
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const forgotPassword = async (emailData) => {
  const config = {
    method: "post",
    url: forgotPasswordRoute,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(emailData),
  };

  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const verifyOTP = async (otpData) => {
  const config = {
    method: "post",
    url: verifyOtpRoute,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(otpData),
  };

  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const resetPassword = async (passwordData) => {
  const config = {
    method: "post",
    url: resetPasswordRoute,
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(passwordData),
  };

  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const verifyToken = async (cookies) => {
  const { userID, token } = cookies;
  const config = {
    method: "get",
    url: `${verifySessionRoute}?userID=${userID}`,
    headers: { Authorization: `Bearer ${token}` },
  };

  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
